export default {
  KJKTopKanzlei: 'KJK - Top Kanzlei',
  KJKStephanKolmann: 'KJK - Dr. Stephan Kolmann',
  KJKTimJakobs: 'KJK - Tim Jakobs',
  KJKCarlChristianKramer: 'KJK - Carl-Christian Kramer'
};
